import { createAction, props } from '@ngrx/store';

import { ControllerPayload, TabPayload } from './tab-controller.model';

export const createOrUpdateTab = createAction('[TabController] Update or create tab', props<TabPayload>());

export const createOrUpdateController = createAction('[TabController] Update or create controller', props<ControllerPayload>());

export const resetTabControllerState = createAction('[TabController] Reset State');
